export default "<p>\n  rating works!\n</p>\n"